export default __webpack_public_path__ + "static/media/Transcript.6851310c.pdf";